import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SVGPureIcon } from '@/ui';
import client from '@/store/client';
import { HelperCore, HelpOther } from '@/common/helper';

import './index.scss';

const name = 'xiaohongshu-note';

const NoteCard = observer(({ data }) => {
  const { cover, link, title } = data;

  /** 跳转 */
  const handleJump = (e) => {
    e.stopPropagation();
    if (!link) {
      HelpOther.toast('无法打开');
    }
    client.openPage(link);
  };

  return (
    <div
      className="xiaohongshu-card group w-full mx-8px cursor-pointer"
      onClick={handleJump}
    >
      <div className="w-full h-168px relative rounded-12px overflow-hidden">
        <img className="w-full h-full object-cover" src={cover} alt="" />
        <div
          className={[
            'w-full h-60px pt-19px absolute left-0 z-1 flex justify-center items-start overflow-hidden',
            'group-hover:bottom-0 bottom-[-60px] transition-all duration-500 ease-in-out',
          ]}
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%)',
          }}
        >
          <span className="w-110px flex items-center justify-center text-white text-12px bg-black bg-opacity-70 hover:bg-opacity-100 rounded-16px py-6px leading-17px">
            查看原文
          </span>
        </div>
      </div>
      <div className="w-full h-40px mt-14px line-clamp-2 leading-20px">
        {title}
      </div>
    </div>
  );
});

const Note = props => {
  const { list = [] } = props;
  const [isFold, setFold] = useState(false);

  if(!list?.length) return null;

  return (
    <div className={[
      'w-[80%] rounded-12px bg-white p-16px mt-16px border-[1px] border-[rgba(0, 0, 0, 0.1)]',
      `${isFold ? 'h-60px' : 'h-300px'} transition-all duration-200 ease-in-out overflow-hidden`,
    ]}>
      <h3 className="h-28px mb-0 flex justify-between items-center text-16px text-black font-bold-600">
        已阅读{list?.length || 0}篇小红书笔记
        <div
          className={[
            `size-18px flex items-center justify-center cursor-pointer`,
            `transition-transform transition-[0.25s] transform ${isFold ? '' : 'rotate-[180deg]'}`,
          ]}
          onClick={() => {
            setFold(_ => !_);
          }}
        >
          <SVGPureIcon
            name="fold"
            className="w-full h-full opacity-50 text-primary-opacity hover:opacity-70"
          />
        </div>
      </h3>
      <div className={`relative xiaohongshu-swiper`}>
        <Swiper
          className="w-full h-222px mt-16px"
          direction="horizontal"
          slidesPerView={'auto'}
          slidesPerGroup={3}
          spaceBetween={16}
          navigation={{
            prevEl: `.swiper-btn-prev-${name}`,
            nextEl: `.swiper-btn-next-${name}`,
          }}
        >
          {list.map((item, index) => {
            return (
              <SwiperSlide key={index + item.cover} className="!w-126px">
                <NoteCard data={item} />
              </SwiperSlide>
            );
          })}
          <div
            className="mask w-50px h-full absolute top-0 right-0"
            style={{
              background:
                'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 5%, #FFF 100%)',
            }}
          ></div>
        </Swiper>
        {/* <div className="text-[rgba(0,0,0,0.5)]"> */}
          <div
            className={[
              `swiper-btn-prev-${name} vh-center size-32px rounded-full`,
              'absolute top-1/2 -left-8px -mt-43px',
              'border-1px border-[rgba(0,0,0,0.1)] bg-white hover:bg-[#f7f7f7] cursor-pointer',
            ]}
          >
            <SVGPureIcon name="swiper_agent_prev" className="size-21px" />
          </div>
          <div
            className={[
              `swiper-btn-next-${name} vh-center size-32px rounded-full`,
              'absolute top-1/2 -right-8px -mt-43px',
              'border-1px border-[rgba(0,0,0,0.1)] bg-white hover:bg-[#f7f7f7] cursor-pointer',
            ]}
          >
            <SVGPureIcon name="swiper_agent_next" className="size-21px" />
          </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default observer(Note);
